export const useCameraLocationName = () => {
  const CameraLocationName = (location: string): string => {
    const cleaned = location
      .replace(/^cctv-/i, "")                 // hapus prefix cctv-
      .replace(/_/g, " ")                     // underscore → spasi
      .replace(/-/g, " ")                     // hyphen → spasi
      .replace(/^UPT(?=[A-Z])/, "UPT ")       // UPT prefix khusus
      .replace(/^TPR(?=[A-Z])/, "TPR ")       // TPR prefix khusus
      .replace(/([a-z])([A-Z])/g, "$1 $2")    // spasi sebelum huruf besar (camelCase)
      .replace(/([A-Za-z])(\d)/g, "$1 $2")    // spasi sebelum angka
      .trim();

    return cleaned;
  };

  return { CameraLocationName };
};
